import ru from './flags/ru.png'
import en from './flags/en.png'
import sr from './flags/sr.png'
import de from './flags/de.png'



export function Flags(lang){

	switch(lang){
		case 'ru':
			return ru;
		case 'en':
			return en;
		case 'de':
			return de;
		case 'sr':
			return sr;
		default:
			return ru;
	}
}

